import { render, staticRenderFns } from "./AddPermissionsType.vue?vue&type=template&id=058e6920"
import script from "./AddPermissionsType.vue?vue&type=script&lang=js"
export * from "./AddPermissionsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports